const alertFlagColors = [{
	key: "Yellow"
}, {
	key: "Red"
}
]

export default alertFlagColors;